module.exports = __webpack_public_path__ + "static/media/foresting.77bd6aa4.png";